import React, { Fragment, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  Button,
  Input,
  NavLink,
  Nav,
  NavItem,
} from "reactstrap";
import { useNavigate } from "react-router";
import { GeneralMedicalRecord, GeneralMedicalRecordList } from "../../../../../apiController";
import { toast } from "react-toastify";

const GeneralMedicalForm = ({ setSteps, patientData }) => {
  const navigate = useNavigate();

  console.warn(patientData)

  const [others, setOthers] = useState(false);
  const [selectedHabits, setSelectedHabits] = useState([]);
  const [isPregnant, setIsPregnant] = useState(false);
  const [record, setRecord] = useState([]);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch
  } = useForm();



  const onSubmit = async (data) => {
    console.warn(data);
    console.warn(selectedHabits);

  const habitsData = {
    alcohol: selectedHabits.includes('alcohol') ? "yes" : " ",
    paan: selectedHabits.includes('paan') ? "yes" : " ",
    tobacco: selectedHabits.includes('tobacco') ? "yes" : " ",
};
    
    const formattedData = {
      id: data.id,
      patient_id: patientData.id,
      astjma: data.asthma ? "yes" : " ",
      epilepsy: data.epilepsy ? "yes" : " ",
      diabets: data.diabetes ? "yes" : " ",
      heart_problem: data.heartproblem ? "yes" : " ",
      blood_disease: data.blooddieases ? "yes" : " ",
      jaundice: data.jaundice ? "yes" : " ",
      others: data.other ? data.other : " ",
      pregnant: data.pregnant ? "yes" : " ",
      due_date: data.dueDate,
      medication: data.medication,
      aspirin: data.aspirin ? "yes" : " ",
      sulfa: data.sulfa ? "yes" : " ",
      local_aneshthetic: data.localaneshthetic ? "yes" : " ",
      penicilin: data.penicilin ? "yes" : " ",
      ibuprofen: data.ibuprofen ? "yes" : " ",
      mention_others: data.allergic,
      ...habitsData // Spread the habits data into the formattedData object
  };

    console.log(formattedData)
    try {

        const response = await GeneralMedicalRecord(formattedData);
        if (response.status === true) {
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (response.status === false) {
          toast.error(response.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }

        
        // navigate(`${process.env.PUBLIC_URL}/patientinfo/:layout>}`, { state: {data: patientData} });
      
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }finally{
      reset({
        asthma: false,
        epilepsy: false,
        diabetes: false,
        heartproblem: false,
        blooddieases: false,
        jaundice: false,
        other: '',
        pregnant: false,
        dueDate: '',
        medication: '',
        aspirin: false,
        sulfa: false,
        anaesthetic: false,
        penicilin: false,
        ibuprofen: false,
        localaneshthetic: false,
        allergic: '',
        // Reset habits to an empty array
        habits: [],
    });
    // Reset selected habits
    setSelectedHabits([]);
    // setTimeout(() => {
    //   window.location.reload();
    // }, 200);
    }
  };

  const handleHabitClick = (habit) => {
    setSelectedHabits((prev) => {
      const newHabits = prev.includes(habit) ? prev.filter((h) => h !== habit) : [...prev, habit];
      setValue('habits', newHabits);
      return newHabits;
    });
    
  };
  // const fetchRecord = async () => {
  //   const response = await GeneralMedicalRecordList();
  //   if (response.status === true) {
  //     const filteredId = response.data.filter(
  //       (item) => item.patient_id === data.id
  //     );
  //     setRecord(filteredId);
  //   }
  // };

  useEffect(() => {
    setValue('habits', selectedHabits);
  }, [selectedHabits, setValue]);

  const isPregnantWatch = watch("pregnant");
  return (
    <Fragment>
      
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-bookmark needs-validation"
      >
        <Row className="p-5">
          <Col sm="12">
            <Row className="mb-5">
              <Label htmlFor="affect">
                {"HAVE YOU EVER SUFFERED FROM ANY OF THE FOLLOWING? (PLEASE TIC)"}
              </Label>
              <div className="d-flex flex-wrap gap-5 mt-3">
                {['asthma', 'epilepsy', 'diabetes', 'heartproblem', 'blooddieases', 'jaundice'].map((condition) => (
                  <Label key={condition} className="d-block d-flex">
                    <Controller
                      control={control}
                      name={condition}
                      render={({ field }) => (
                        <Input
                          type="checkbox"
                          {...field}
                          className={`form-control checkbox_animated ${errors[condition] && "is-invalid"}`}
                        />
                      )}
                    />
                    {condition.charAt(0).toUpperCase() + condition.slice(1)}
                  </Label>
                ))}
                <Label className="d-block d-flex">
                  <Input
                    className="checkbox_animated"
                    type="checkbox"
                    onChange={() => setOthers(!others)}
                  />
                  {"Others"}
                </Label>
              </div>
              {others && (
                <FormGroup className="mb-3 mt-3 d-flex">
                  <Label htmlFor="other">{"If any other, Mention it"}</Label>
                  <Controller
                    control={control}
                    name="other"
                    render={({ field }) => (
                      <Input
                        className={`form-control other_under ${errors.other && "is-invalid"}`}
                        type="text"
                        {...field}
                      />
                    )}
                  />
                </FormGroup>
              )}
            </Row>
            {patientData.gender === "female" && (
              <Row className="mb-5 mt-5">
                <Col sm="12">
                  <Label htmlFor="pregnant">{"WOMAN - (PLEASE TIC IF YOU ARE PREGNANT)"}</Label>
                  <Label className="d-block d-flex">
                    <Controller
                      control={control}
                      name="pregnant"
                      render={({ field }) => (
                        <Input
                          type="checkbox"
                          {...field}
                          checked={isPregnantWatch}
                          onChange={(e) => {
                            setIsPregnant(e.target.checked);
                            setValue("pregnant", e.target.checked);
                          }}
                          className={`form-control checkbox_animated ${errors.pregnant && "is-invalid"}`}
                        />
                      )}
                    />
                    {"PREGNANT"}
                  </Label>
                </Col>
              </Row>
            )}

            {isPregnant && (
              <Row className="mb-5 mt-5">
                <FormGroup className="mb-3 mt-3">
                  <Label htmlFor="dueDate">{"Due Date"}</Label>
                  <Controller
                    control={control}
                    name="dueDate"
                    render={({ field }) => (
                      <Input
                        type="date"
                        {...field}
                        className={`form-control ${errors.dueDate && "is-invalid"}`}
                      />
                    )}
                  />
                </FormGroup>
              </Row>
            )}

            <Row className="mb-5 mt-5">
              <Nav tabs pills>
                {['alcohol', 'paan', 'tobacco'].map((habit) => (
                  <NavItem key={habit}>
                    <NavLink
                      className={`form-control ${selectedHabits.includes(habit) && "habitsBorder"}`}
                      onClick={() => handleHabitClick(habit)}
                    >
                      {habit.charAt(0).toUpperCase() + habit.slice(1)}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Row>

            <Row className="mb-5 mt-5">
              <Label htmlFor="medication">{"MEDICATION"}</Label>
              <FormGroup className="mb-3 mt-3">
                <Controller
                  control={control}
                  name="medication"
                  render={({ field }) => (
                    <Input
                      type="textarea"
                      {...field}
                      className={`form-control ${errors.medication && "is-invalid"}`}
                    />
                  )}
                />
              </FormGroup>
            </Row>

            <Row className="mb-5 mt-5">
              <Label htmlFor="allergic">{"ARE YOU ALLERGIC TO ANY OF THE FOLLOWING?"}</Label>
              <div className="d-flex flex-wrap gap-5 mt-3">
                {['aspirin', 'sulfa', 'anaesthetic', 'penicillin', 'ibuprofen', 'localaneshthetic'].map((allergy) => (
                  <Label key={allergy} className="d-block d-flex">
                    <Controller
                      control={control}
                      name={allergy}
                      render={({ field }) => (
                        <Input
                          type="checkbox"
                          {...field}
                          className={`form-control checkbox_animated ${errors[allergy] && "is-invalid"}`}
                        />
                      )}
                    />
                    {allergy.charAt(0).toUpperCase() + allergy.slice(1)}
                  </Label>
                ))}
               
              </div>
            </Row>
            <FormGroup className="mb-3 mt-3 d-flex">
                  <Label htmlFor="allergic">{"If any other, Mention it"}</Label>
                  <Controller
                    control={control}
                    name="allergic"
                    render={({ field }) => (
                      <Input
                        type="text"
                        {...field}
                        className={`form-control other_under ${errors.allergic && "is-invalid"} border-0`}
                      />
                    )}
                  />
                </FormGroup>

            <div className="text-end btn-mb">
              <Button className="secondary me-2" onClick={() => reset()}>
                {"Cancel"}
              </Button>
              <Button className="primary" type="submit">
                {"Submit"}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default GeneralMedicalForm;

